<template>
  <v-popover
    :auto-hide="true"
    :class="[context]"
    :container="'#root .router-view'"
    :offset="24"
    :open="popoverOpen"
    :placement="'auto'"
    :popover-class="['share-popover', context]"
    :trigger="'manual'"
    @hide="handlePopoverHide"
  >
    <button
      class="footer-button"
      @click="triggerShare"
    >
      <icon
        name="share-uui"
      ></icon>
    </button>
    <template v-slot:popover>
      <div class="heading">
        {{ title }}
      </div>
      <div class="subheading">
        {{ text }}
      </div>
      <share-box :url="url" />
    </template>
  </v-popover>
</template>

<script>
import Icon from '@/components/singletons/icon';
import ShareBox from '@components/share/shareBox';

export default {
  components: {
    Icon,
    ShareBox,
  },
  props: {
    category: {
      type: Object,
    },
    context: {
      type: String,
      default: 'flashcard',
    },
    flashcard: {
      type: Object,
    },
  },
  data() {
    return {
      popoverOpen: false,
    };
  },
  computed: {
    config() {
      return this.$store.getters['productVars/get']['flashcardShareMessage']?.parsedValue;
    },
    message() {
      return this.config?.message_text;
    },
    title() {
      return this.config?.title || 'Ask a Friend';
    },
    text() {
      return this.config?.text || 'Share this question with a BFF.';
    },
    url() {
      if (this.flashcard && this.config) {
        let url = `${this.config.url}?fid=${this.flashcard.id}`;

        if (this.config.sc) {
          url += `&sc=${this.config.sc}`;
        }

        return url;
      }
    },
  },
  methods: {
    triggerShare() {
      this.popoverOpen = !this.popoverOpen;
    },
    handlePopoverHide() {
      this.popoverOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .footer-button {
    height: 28px;
    width: 28px;
    display: grid;
    place-items: center;
    background-color: transparent;
    padding: 0;
    border: none;
  }
</style>
